import { Button, View } from "@/components/ui";
import React from "react";
import { WhatsappSupportBannerBall } from "@/components/shared/whatsapp-support-banner";
import { onChatSales } from "@/lib/chat-sales";
import { cn } from "@/lib/utils";
import { generateBookingChatSalesMessage } from "@/lib/chat-sales";
import type { ServiceName } from "@/types/service";

export function NativeActionNavigation({
  name,
  isReviewService,
  onClickButton,
  buttonText,
  leftRender,
  disabled,
}: {
  name: ServiceName;
  isReviewService?: boolean;
  buttonText?: string;
  disabled?: boolean;
  leftRender?: React.ReactElement;
  onClickButton(): void;
}) {
  return (
    <>
      <View className="native:hidden h-16 p-6 md:hidden" />
      <View
        className={cn(
          "fixed bottom-0 left-0 z-10 flex w-full flex-row gap-4 rounded-lg border-secondary-border p-4 shadow md:hidden",
          { "border bg-white": !isReviewService },
        )}
      >
        {!isReviewService && (
          <WhatsappSupportBannerBall
            onClick={() =>
              onChatSales(true, generateBookingChatSalesMessage(name))
            }
          />
        )}
        {leftRender}

        <Button
          variant="primary"
          color="CTA"
          disabled={disabled}
          fullWidth="full"
          size="md"
          iconAlignment="end"
          iconName="arrowRight"
          onClick={onClickButton}
          children={buttonText ?? ""}
        />
      </View>
    </>
  );
}
